export const myResumeUrl = 'https://nodejsresumeapi.herokuapp.com';


// WEBPACK FOOTER //
// ./src/config.js/Config.js